export interface PageMetadata {
  title: string;
  description: string;
}

export const authMetadata: Record<string, PageMetadata> = {
  forgotPassword: {
    title: 'Forgot Password | TheQuickAssist',
    description: 'Recover your TheQuickAssist account password to get back to building and managing your custom AI chatbots.',
  },
  login: {
    title: 'Login | TheQuickAssist — Whatsapp CRM & AI Agent',
    description: 'Log in to your TheQuickAssist account to build, configure, and monitor your custom no-code AI chatbots and agents.',
  },
  onboarding: {
    title: 'Setup AI Assistant | TheQuickAssist Onboarding',
    description: 'Complete the onboarding steps to set up your profile and configure your first AI chatbot.',
  },
  register: {
    title: 'Register | TheQuickAssist — WhatsApp CRM & AI Agent',
    description: 'Create a free TheQuickAssist account today to build intelligent, no-code AI chatbots for customer support and lead generation.',
  },
  remoteLogin: {
    title: 'Remote Login | TheQuickAssist',
    description: 'Secure remote access log in portal for TheQuickAssist users.',
  },
  resetPassword: {
    title: 'Reset Password | TheQuickAssist',
    description: 'Create a new secure password for your TheQuickAssist account.',
  },
  verifyOtp: {
    title: 'Verify OTP | TheQuickAssist',
    description: 'Enter the One-Time Password sent to your email to verify and access your account.',
  },
};
